import React from 'react';

export default function Header() {
    return (
        <div>
            Change Account
        </div>
    )
}
